import React from 'react';
import { useTranslations } from 'next-intl';
import type { PhoneData } from '@/features/Phones/model/types';
import { PhoneNumber } from '@/features/Phones/ui/PhoneNumber';
import { Slider, SliderPagination } from '@/widgets/Slider';
import { classNames } from '@/shared/lib/classnames/classnames';
interface PhoneSliderProps {
  phones: PhoneData[];
  viewIndex: number;
  onViewIndexChange: (index: number) => void;
  onPhoneCallPreview: (phoneNumber: PhoneData) => void;
}
export const PhoneSlider: React.FC<PhoneSliderProps> = ({
  phones,
  viewIndex,
  onViewIndexChange,
  onPhoneCallPreview
}) => {
  const t = useTranslations();
  if (phones.length === 0) return null;
  return <Slider itemTag="div" activeOnView scrollByItem btnBgVariant={{
    variant: 'glassmorphism'
  }} onViewIndexChange={onViewIndexChange} data-sentry-element="Slider" data-sentry-component="PhoneSlider" data-sentry-source-file="PhoneSlider.tsx">
      {phones.map((phone, index) => <a key={index} href={`tel:${phone.phone}`} onClick={() => onPhoneCallPreview(phone)} draggable={false} className={classNames('flex h-14 min-w-72 select-none flex-col items-center justify-center rounded-2xl bg-white/10 p-3', {
      'w-full': phones.length === 1
    })}>
          <PhoneNumber className="text-white" phone={phone.phone} />
          <span className="text-sm text-white">{t('doctor.phoneAndDialog.straight_call')}</span>
        </a>)}
      <SliderPagination count={phones.length} activeIndex={viewIndex} data-sentry-element="SliderPagination" data-sentry-source-file="PhoneSlider.tsx" />
    </Slider>;
};